<ng-template #bodyLabelActions>
  <cam-link size="sm" [underline]="false" icon="mail" (action)="this.templateChoiceOpen.set(true)">
    {{ 'communication.email.template.choose' | translate }}
  </cam-link>
</ng-template>

<ng-template #recipientLabelActions>
  <div class="align-center g-space-sm">
    <cam-link
      size="sm"
      [underline]="false"
      [icon]="this.ccVisible() ? 'close' : 'plus'"
      (action)="this.ccVisible.set(!this.ccVisible())"
    >
      {{ 'communication.email.cc' | translate }}
    </cam-link>
  </div>
</ng-template>

<cam-panel-form-layout
  [askValidation$]="this.askValidation$"
  [formValidity]="this.formValidity"
  [parentRequestState]="this.requestState"
  class="full-width"
>
  <div class="d-flex flex-column m-space-sm g-space-sm">
    <cam-form
      [inputs]="this.form()"
      [askValidation$]="this.askValidation$"
      [canDisplayButton]="false"
      (valid)="this.validation($event)"
      (isFormValid)="this.formValidity.set($event)"
    ></cam-form>

    <div class="flex-column g-space-xs">
      <cam-input-checkbox
        [input]="this.attachmentsEnabledInput"
        [standalone]="true"
        (valueChanged)="this.attachmentsEnabled.set($event)"
      ></cam-input-checkbox>
      @if (this.attachmentsEnabled()) {
        <cam-communication-attachments-cards
          [initialAttachments]="this.attachments()"
          [documentsIds]="this.documentsPools()"
          (attachments)="this.onAttachments($event)"
        ></cam-communication-attachments-cards>
      }
    </div>
  </div>
</cam-panel-form-layout>

@if (this.templateChoiceOpen()) {
  <cam-layout-full-panel
    type="modal"
    size="lg"
    [title]="'communication.email.template.label' | translate"
    [toggleState]="this.templateChoiceOpen()"
    (closeEvent)="this.templateChoiceOpen.set(false)"
  >
    <cam-communication-template-choice
      [type]="this.CommunicationType.Mail"
      (selected)="this.selectTemplate($event)"
    ></cam-communication-template-choice>
  </cam-layout-full-panel>
}
